<template>
	<div class="inviteinok" :style="'background-image:url('+img.pagebg+');height:'+winHeight+'px;background-size: 100% '+winHeight+'px;'">
		<div class="div_mask">
			<div class="f-16 f-w" style="margin-top: 80px;align-items: center;display: inline-flex;color: #333333;">“凌志范儿” <img class="sficon" :src="img.sficon">  影响力认证{{is_audit_name}}</div>
			<div class="f-16" style="margin-top: 14px;padding: 0 45px;color: #666666;" v-if="is_audit==0">审核时间 1～3 个工作日</div>
			<div class="f-16" style="margin-top: 14px;padding: 0 45px;color: #666666;" @click="inviteAgain" v-if="is_audit==2">重新申请<img class="nextimg" :src="img.nextimg"></div>
			<div class="f-12" style="margin-top: 25px;padding: 2px 45px;color: #333333;letter-spacing: 1px;">认证成功后，您将：</div>
			<div class="f-12" style="padding: 2px 45px;color: #333333;align-items: center;display: flex;justify-content: center;letter-spacing: 1px;">获得「凌志范儿」<img class="sficon" :src="img.sficon"> 影响力认证标识</div>
			<div class="f-12" style="padding: 2px 45px;color: #333333;letter-spacing: 1px;">发布动态会获得更多曝光展示 </div>
			<div class="f-12" style="padding: 2px 45px;color: #333333;letter-spacing: 1px;">受邀参与各种活动</div>
			<div class="f-12" style="padding: 2px 45px;color: #333333;letter-spacing: 1px;letter-spacing: 1px;">可以参与征文投稿、提问回答</div>
			<div class="f-12" style="padding: 2px 45px;color: #333333;letter-spacing: 1px;">获得更多权益与专属勋章</div>
			<div style="margin-top: 25px;">
				<img class="qrcode" :src="img.lexus">
			</div>
			<div class="f-12" style="color: #999999;margin-bottom: 5px;">长按添加凌志范儿官方微信</div>
			<div class="f-12" style="color: #999999;margin-bottom: 5px;" v-clipboard="value" v-clipboard:success="clipboardSuccessHandler" v-clipboard:error="clipboardErrorHandler">（微信号 lingzhifaner ）</div>
			<!-- <div class="invitebtn" @click="invitein">我知道了</div> -->
		</div>
	</div>
</template>
<script>
	import member from '../../../api/member/memberinfo';
	import common from '../../../api/common';
	import { mapState } from 'vuex';
	import { Grid, GridItem,Field,Button,Icon,Toast } from 'vant';
	export default {
		data () {
			return {
				winHeight:568,
				otherinfo:'',
				is_audit_name:'审核中',
				is_audit:0,
				img:{
					sficon: require('../../../assets/img/lexus/approve/newicon.png'),
					lexus: require('../../../assets/img/lexus/approve/qrcode.png'),
					pagebg:require('../../../assets/img/lexus/approve/approveno_bg.png'),
					nextimg: require('../../../assets/img/lexus/approve/nextimg.png'),
				}
			}
		},
		computed: {
			...mapState({
				user: state => state.param.user,
				source: state => state.param.source
			})
		},
		created () {
			var h = document.documentElement.clientHeight || document.body.clientHeight;
			this.winHeight=h
			this.$store.commit('param/show', false)
			this.$appService.isShowReturn({state: false})
			this.$appService.isTabbar({state: true})

			this.$appService.getToken(v => {
				if(v.token) {
					this.$store.dispatch('param/setToken', v.token)
				} else {
					this.$appService.needLogin()
				}
			})
			if(this.$route.query.token){
				this.source = this.$route.query.source
				this.token = this.$route.query.token
				this.user_id = this.$route.query.userid
				this.otherid = this.$route.query.otherid
				this.$store.dispatch('param/setToken', this.$route.query.token)
				this.getUserOther(this.$route.query.userid)
			}else{
				this.source = this.$route.params.source
				this.token = this.$route.params.token
				this.$store.dispatch('param/setToken', this.$route.params.token)
				this.user_id = this.$route.params.user_id
				this.getActivity(this.$route.params.user_id)
				this.getUserOther(this.$route.params.user_id)
			}
			var params={
				event_code: '邀请认证',
				event_id: '',
				title: '',
				value: '',
				path: '/Lexus/Approve/LexusInviteok.vue',
				user_id: this.user_id ? this.user_id : 0,
				source: this.source
			}
			common.BurialPoint(params).then(res => {
				if(res.data.state==1){

				}
			})
			var apppar={
				title:this.$route.meta.title
			}
			this.$appService.changeTitle(apppar)
		},
		methods: {
			getActivity(id){
				var params={
					user_id:parseInt([id]),
				}
				common.getActivity(params,11).then(res => {
					if(res.data.state==1){
						if(res.data.data.enroll_share_pic){
							this.img.lexus=res.data.data.enroll_share_pic
						}
						if(res.data.data.background_pic){
							this.img.pagebg=res.data.data.background_pic
						}
						this.activeinfo=res.data.data
					}
				})
			},
			getUserOther(id){
				var params={
					user_id:parseInt([id]),
					source:this.source
				}
				member.userOther(params).then(res => {
					if(res.data.state==1){
						this.list=res.data.data.auth.title
						this.otherinfo=res.data.data

              if(res.data.data.auth.is_audit==0){//审核中
              	this.is_audit=0
              	this.is_audit_name='审核中'
            }else if(res.data.data.auth.is_audit==1){//审核通过
            	this.is_audit=1
            	this.is_audit_name='审核通过'
            }else if(res.data.data.auth.is_audit==2){//审核不通过
            	this.is_audit=2
            	this.is_audit_name='审核未通过'
            }
        }
    })
			},
			invitein(){
				if(this.source==9){
					wx.miniProgram.reLaunch({url: '/pages/index/index'})
				}else{
					var params={
						url:this.weburl+'/lexus?source='+this.source ,
						isReturn: true 
					}
					this.$appService.openWebView(params)
				}
			},
			inviteAgain(){
				if(this.source==9){
					this.$router.push({name:'LexusInvite',params:{source:this.source,token:this.token,user_id:this.user_id}});

				}else{
					var params={
						url:this.weburl+'/lexus/invite?source='+this.source ,
						isReturn: true 
					}
					this.$appService.openWebView(params)
				}
			},
			clipboardSuccessHandler ({ value, event }){
				
				Toast('复制成功');
			},
			clipboardErrorHandler ({ value, event }) {
				console.log('error', value)
			}
		},
		components: {
			[Grid.name]: Grid,
			[GridItem.name]: GridItem,
			[Field.name]:Field,
			[Button.name]:Button,
			[Icon.name]:Icon,
			[Toast.name]:Toast
		}
	}
</script>
<style lang="scss">
.inviteinok{
	text-align: center;
	width: 100%;
	.div_mask{
		width: 100%;
		height: 100%;
			// background: rgba(0,0,0,.8);
		}
		.sficon{
			width: 18px;
			height: 18px;
			margin-right: 3px;
		}
		.qrcode{
			width: 160px;
			height: 160px;
		}
		.invitebtn{
			font-size: 14px;
			text-align: center;
			background: #605C6B;
			color: #fff;
			padding:15px 30px;
			position: fixed;
			top: 73%;
			left: 34%;
		}
		.nextimg{
			width: 13px;
			height:12px;
			margin-left: 5px;
		}
		*{
			-webkit-user-select: none;/*禁用手机浏览器的用户选择功能 */
			-moz-user-select: none;
			-webkit-touch-callout: none;
			-ms-user-select:none; /*IE10*/
			user-select:none;
		}
	}
</style>
